export const getReservationPauseDate = (pauseUntil?: string | null): Date | null => {
    if (!pauseUntil) return null;

    const date = new Date(pauseUntil);
    return Number.isFinite(date.getTime()) ? date : null;
};

// Match order scheduling: the cutoff itself is bookable, but past times are not.
export const isReservationTimeAvailable = (time: Date, pauseUntil?: string | null, now = new Date()): boolean => {
    const pauseDate = getReservationPauseDate(pauseUntil);

    return time.getTime() > now.getTime() && (!pauseDate || time.getTime() >= pauseDate.getTime());
};
